/**
 * Centralized business / brand configuration for MGL Cleaning Solutions.
 * All hard-coded brand details should pull from here.
 */
import logoUrl from "@/assets/images/logo.webp";

export const siteConfig = {
  name: "MGL Cleaning Solutions",
  shortName: "MGL Cleaning",
  legalName: "MGL Cleaning Solutions",
  owner: "Magaly Morales",
  tagline: "Trusted House & Office Cleaning in Germantown, TN",
  description:
    "Locally owned cleaning company in Germantown, TN serving homes and offices across Collierville, Cordova, Bartlett, Eads, East Memphis, and Memphis. Deep cleaning, regular cleaning, move-in / move-out, one-time, and office cleaning — Monday through Friday, 8 AM to 5 PM.",

  domain: "mglcleaningtn.com",
  url: "https://mglcleaningtn.com",

  phone: "(901) 864-4659",
  phoneHref: "tel:+19018644659",

  email: "Mgacleaningsolutions@gmail.com",
  emailHref: "mailto:Mgacleaningsolutions@gmail.com",

  address: {
    street: "1827 Oak Hill Cove",
    city: "Germantown",
    state: "TN",
    postalCode: "38138",
    region: "Shelby County",
    serviceRadius: "25 miles",
  },

  hours: {
    summary: "Mon – Fri · 8 AM – 5 PM",
    days: "Monday – Friday",
    time: "8:00 AM – 5:00 PM",
  },

  /** Nav/footer logo — WebP (with alpha), Vite-hashed for long cache. Favicon stays PNG. */
  logo: logoUrl,
  favicon: "/mgl-cleaning-solutions-logo.png",
  /** Social cards render transparency as black, so share the flat JPEG. */
  ogImage: "/mgl-cleaning-solutions-logo.jpeg",

  social: {
    instagram:
      "https://www.instagram.com/mglcleaningsolutions?igsh=eWs3dzZ0azdldnly&utm_source=qr",
    facebook: null,
    tiktok: null,
    yelp: null,
  },

  /** Client declined a returning-customer / referral discount. */
  discount: null,

  widgets: {
    chatWidgetId: "6a62cabd725f47c26c78d35b",
    chatLoaderSrc: "https://widgets.leadconnectorhq.com/loader.js",
    chatResourcesUrl: "https://widgets.leadconnectorhq.com/chat-widget/loader.js",

    reviewScriptSrc: "https://reputationhub.site/reputation/assets/review-widget.js",
    reviewIframeSrc:
      "https://reputationhub.site/reputation/widgets/review_widget/nY7WwBIRpi1xH94EnvQz?widgetId=6a65295297c889c9bfc798f7",

    formIframeSrc: "https://link.systemic-digital.net/widget/form/13dLHv2cV12Ka24wL347",
    formScriptSrc: "https://link.systemic-digital.net/js/form_embed.js",
    formId: "13dLHv2cV12Ka24wL347",
    formName: "Website Form",
    /** Initial iframe height from the embed code; form_embed.js resizes after load. */
    formHeight: 669,
  },

  serviceAreas: [
    "Germantown, TN",
    "Collierville, TN",
    "Cordova, TN",
    "Bartlett, TN",
    "Eads, TN",
    "East Memphis, TN",
    "Memphis, TN",
  ],
} as const;

export type SiteConfig = typeof siteConfig;
